import { computed } from 'vue';
import { useSpecificationConfirmClaimsService } from './use-specification-confirm-claims-service';
import type { SpecificationConfirmClaimItem, SpecificationConfirmClaimTree } from '@/domains/specification/types/specification-confirm-claims';
import { createSharedComposable } from '@vueuse/core';

export const useClaimTree = createSharedComposable(() => {
    const { serviceState } = useSpecificationConfirmClaimsService();

    const claimTree = computed<SpecificationConfirmClaimTree>(() => serviceState.value.formData.claimTree.content);

    const claimTreeNumMap = computed<Record<string, SpecificationConfirmClaimItem>>(() => {
        const acc: Record<string, SpecificationConfirmClaimItem> = {};
        const mapInArr = (items: SpecificationConfirmClaimItem[]) => {
            items.forEach(item => {
                acc[item.num] = item;
                mapInArr(item.children || []);
            });
        };
        mapInArr(claimTree.value);
        return acc;
    });

    const getClaimByNum = (...nums: string[]) => {
        return nums.map(num => claimTreeNumMap.value[num]);
    };

    return {
        claimTree,
        claimTreeNumMap,
        getClaimByNum,
    };
});
